import {
  Calendar,
  Package,
  Truck,
  AlertTriangle,
  CheckCircle,
  Clock,
  BarChart2,
  Users,
  FileText,
} from 'lucide-react'

export const KPIData = {
  totalStock: 1250000, // tons
  availableStock: 980000, // tons
  sphpToday: 450, // tons
  foodAid: 1200, // tons
  criticalWarehouses: 5,
  agingStock: 15000, // tons (> 6 months)
}

export const programs = [
  {
    id: 'PROG-001',
    name: 'SPHP Beras 2025',
    type: 'SPHP',
    period: '01 Jan 2025 - 31 Des 2025',
    status: 'Running',
    quota: 1200000,
    realization: 450000,
    pic: 'Budi Santoso',
    lastUpdated: '2025-05-20',
  },
  {
    id: 'PROG-002',
    name: 'Bantuan Pangan Tahap I 2025',
    type: 'Bantuan Pangan',
    period: '01 Jan 2025 - 31 Mar 2025',
    status: 'Closed',
    quota: 660000,
    realization: 658000,
    pic: 'Siti Aminah',
    lastUpdated: '2025-04-05',
  },
  {
    id: 'PROG-003',
    name: 'CPP Jagung Q2',
    type: 'CPP',
    period: '01 Apr 2025 - 30 Jun 2025',
    status: 'Approved',
    quota: 200000,
    realization: 0,
    pic: 'Rudi Hartono',
    lastUpdated: '2025-05-15',
  },
  {
    id: 'PROG-004',
    name: 'Bantuan Pangan Tahap II 2025',
    type: 'Bantuan Pangan',
    period: '01 Apr 2025 - 30 Jun 2025',
    status: 'Running',
    quota: 660000,
    realization: 220000,
    pic: 'Siti Aminah',
    lastUpdated: '2025-05-21',
  },
  {
    id: 'PROG-005',
    name: 'SPHP Gula Pasir 2025',
    type: 'SPHP',
    period: '01 Jan 2025 - 31 Des 2025',
    status: 'Running',
    quota: 50000,
    realization: 18000,
    pic: 'Andi Wijaya',
    lastUpdated: '2025-05-20',
  },
  {
    id: 'PROG-006',
    name: 'SPHP Minyak Goreng 2025',
    type: 'SPHP',
    period: '01 Jan 2025 - 31 Des 2025',
    status: 'Running',
    quota: 80000,
    realization: 32000,
    pic: 'Dewi Lestari',
    lastUpdated: '2025-05-20',
  },
]

export const stockData = [
  {
    id: 'LOT-JKT-001',
    warehouse: 'Gudang Kelapa Gading',
    commodity: 'Beras Premium',
    quantity: 500,
    location: 'A-01-02',
    quality: 'Grade A',
    entryDate: '2025-01-15',
    aging: 125,
    status: 'Available',
  },
  {
    id: 'LOT-JKT-002',
    warehouse: 'Gudang Kelapa Gading',
    commodity: 'Beras Medium',
    quantity: 1200,
    location: 'B-05-01',
    quality: 'Grade B',
    entryDate: '2024-11-20',
    aging: 181,
    status: 'Available',
  },
  {
    id: 'LOT-SBY-001',
    warehouse: 'Gudang Buduran',
    commodity: 'Jagung Pakan',
    quantity: 3000,
    location: 'Silo-01',
    quality: 'Standard',
    entryDate: '2025-03-10',
    aging: 71,
    status: 'Allocated',
  },
  {
    id: 'LOT-MKS-005',
    warehouse: 'Gudang Panaikang',
    commodity: 'Beras Medium',
    quantity: 200,
    location: 'C-02-04',
    quality: 'Grade C',
    entryDate: '2024-05-10',
    aging: 375,
    status: 'Blocked',
  },
  {
    id: 'LOT-JKT-003',
    warehouse: 'Gudang Kelapa Gading',
    commodity: 'Gula Pasir',
    quantity: 800,
    location: 'D-03-01',
    quality: 'Premium',
    entryDate: '2025-02-20',
    aging: 89,
    status: 'Available',
  },
  {
    id: 'LOT-JKT-004',
    warehouse: 'Gudang Cibitung',
    commodity: 'Minyak Goreng Curah',
    quantity: 1500,
    location: 'E-01-05',
    quality: 'Standard',
    entryDate: '2025-03-15',
    aging: 66,
    status: 'Available',
  },
  {
    id: 'LOT-SBY-002',
    warehouse: 'Gudang Buduran',
    commodity: 'Kedelai Lokal',
    quantity: 500,
    location: 'F-02-03',
    quality: 'Grade A',
    entryDate: '2025-04-01',
    aging: 49,
    status: 'Available',
  },
  {
    id: 'LOT-MDN-001',
    warehouse: 'Gudang Medan Baru',
    commodity: 'Tepung Terigu',
    quantity: 600,
    location: 'G-01-02',
    quality: 'Premium',
    entryDate: '2025-03-25',
    aging: 56,
    status: 'Available',
  },
  {
    id: 'LOT-JKT-005',
    warehouse: 'Gudang Kelapa Gading',
    commodity: 'Daging Sapi Beku',
    quantity: 150,
    location: 'Cold-01',
    quality: 'Grade A',
    entryDate: '2025-05-10',
    aging: 10,
    status: 'Available',
  },
  {
    id: 'LOT-SBY-003',
    warehouse: 'Gudang Buduran',
    commodity: 'Daging Ayam Beku',
    quantity: 200,
    location: 'Cold-02',
    quality: 'Grade A',
    entryDate: '2025-05-12',
    aging: 8,
    status: 'Available',
  },
  {
    id: 'LOT-JKT-006',
    warehouse: 'Gudang Cibitung',
    commodity: 'Telur Ayam',
    quantity: 300,
    location: 'H-02-01',
    quality: 'Fresh',
    entryDate: '2025-05-18',
    aging: 2,
    status: 'Available',
  },
  {
    id: 'LOT-MDN-002',
    warehouse: 'Gudang Medan Baru',
    commodity: 'Bawang Merah',
    quantity: 250,
    location: 'I-01-03',
    quality: 'Grade A',
    entryDate: '2025-05-15',
    aging: 5,
    status: 'Available',
  },
  {
    id: 'LOT-JKT-007',
    warehouse: 'Gudang Kelapa Gading',
    commodity: 'Bawang Putih',
    quantity: 180,
    location: 'I-02-01',
    quality: 'Grade A',
    entryDate: '2025-05-14',
    aging: 6,
    status: 'Available',
  },
  {
    id: 'LOT-SBY-004',
    warehouse: 'Gudang Buduran',
    commodity: 'Cabai Merah',
    quantity: 120,
    location: 'J-01-02',
    quality: 'Grade B',
    entryDate: '2025-05-17',
    aging: 3,
    status: 'Available',
  },
]

export const recentExceptions = [
  {
    id: 'EX-001',
    type: 'Quality',
    message: 'Kadar air tinggi (15%) di Gudang Panaikang',
    date: '2025-05-20',
    severity: 'High',
  },
  {
    id: 'EX-002',
    type: 'Distribution',
    message: 'POD terlambat > 3 hari (Transporter A)',
    date: '2025-05-19',
    severity: 'Medium',
  },
  {
    id: 'EX-003',
    type: 'Stock',
    message: 'Selisih SO -50kg di Gudang Kelapa Gading',
    date: '2025-05-18',
    severity: 'Low',
  },
  {
    id: 'EX-004',
    type: 'Quality',
    message: 'Suhu cold storage melebihi batas di Gudang Buduran',
    date: '2025-05-20',
    severity: 'High',
  },
  {
    id: 'EX-005',
    type: 'Stock',
    message: 'Stok bawang merah menipis di Gudang Medan',
    date: '2025-05-19',
    severity: 'Medium',
  },
]

export const regionalDistribution = [
  { region: 'DKI Jakarta', target: 50000, realization: 42000 },
  { region: 'Jawa Barat', target: 120000, realization: 98000 },
  { region: 'Jawa Tengah', target: 110000, realization: 105000 },
  { region: 'Jawa Timur', target: 115000, realization: 110000 },
  { region: 'Sulawesi Selatan', target: 40000, realization: 35000 },
  { region: 'Sumatera Utara', target: 35000, realization: 30000 },
]

export const warehouses = [
  'Gudang Kelapa Gading',
  'Gudang Cibitung',
  'Gudang Buduran',
  'Gudang Panaikang',
  'Gudang Medan Baru',
  'Gudang Makassar',
  'Gudang Palembang',
]

// Komoditas Pangan yang Ditangani BULOG
export const commodities = [
  // Beras (Komoditas Utama)
  'Beras Premium',
  'Beras Medium',
  'Beras SPHP',
  'Beras Bantuan Pangan',

  // Jagung
  'Jagung Pakan',
  'Jagung Pipilan Kering',

  // Kedelai
  'Kedelai Lokal',
  'Kedelai Import',

  // Gula
  'Gula Pasir Premium',
  'Gula Pasir Lokal',
  'Gula Rafinasi',

  // Minyak Goreng
  'Minyak Goreng Curah',
  'Minyak Goreng Kemasan',

  // Tepung
  'Tepung Terigu Premium',
  'Tepung Terigu Medium',

  // Daging
  'Daging Sapi Beku',
  'Daging Sapi Segar',
  'Daging Ayam Beku',
  'Daging Ayam Segar',

  // Telur
  'Telur Ayam Ras',

  // Bawang
  'Bawang Merah',
  'Bawang Putih',

  // Cabai
  'Cabai Merah',
  'Cabai Rawit',

  // Garam
  'Garam Konsumsi',
  'Garam Industri',
]

// Kategori Komoditas
export const commodityCategories = {
  'Pangan Pokok': [
    'Beras Premium',
    'Beras Medium',
    'Beras SPHP',
    'Jagung Pipilan Kering',
    'Tepung Terigu Premium',
    'Tepung Terigu Medium',
  ],
  'Pangan Strategis': [
    'Gula Pasir Premium',
    'Gula Pasir Lokal',
    'Minyak Goreng Curah',
    'Minyak Goreng Kemasan',
    'Daging Sapi Beku',
    'Daging Ayam Beku',
  ],
  Hortikultura: ['Bawang Merah', 'Bawang Putih', 'Cabai Merah', 'Cabai Rawit'],
  'Pakan Ternak': ['Jagung Pakan'],
  'Protein Hewani': [
    'Daging Sapi Segar',
    'Daging Sapi Beku',
    'Daging Ayam Segar',
    'Daging Ayam Beku',
    'Telur Ayam Ras',
  ],
  Lainnya: [
    'Kedelai Lokal',
    'Kedelai Import',
    'Garam Konsumsi',
    'Garam Industri',
  ],
}

export const outlets = [
  {
    id: 'OUT-001',
    name: 'Toko Berkah Jaya',
    owner: 'H. Ahmad',
    region: 'Pasar Kramat Jati',
    type: 'Pengecer',
    status: 'Aktif',
    phone: '0812-3456-7890',
  },
  {
    id: 'OUT-002',
    name: 'RPK Melati',
    owner: 'Ibu Susi',
    region: 'Tebet',
    type: 'RPK',
    status: 'Aktif',
    phone: '0813-4567-8901',
  },
  {
    id: 'OUT-003',
    name: 'Sumber Rejeki',
    owner: 'Bpk. Budi',
    region: 'Pasar Minggu',
    type: 'Pengecer',
    status: 'Aktif',
    phone: '0814-5678-9012',
  },
  {
    id: 'OUT-004',
    name: 'Toko Makmur',
    owner: 'Ibu Ani',
    region: 'Cibubur',
    type: 'Pengecer',
    status: 'Aktif',
    phone: '0815-6789-0123',
  },
  {
    id: 'OUT-005',
    name: 'Pasar Segar Sentosa',
    owner: 'Bpk. Hendra',
    region: 'Tanah Abang',
    type: 'Pasar Modern',
    status: 'Aktif',
    phone: '0816-7890-1234',
  },
]

export const priceMonitoring = [
  {
    id: 'PM-001',
    date: '20 Mei 2025',
    outlet: 'Toko Berkah Jaya',
    item: 'Beras SPHP',
    price: 11500,
    het: 10900,
    diff: 600,
    status: 'Violation',
  },
  {
    id: 'PM-002',
    date: '20 Mei 2025',
    outlet: 'RPK Melati',
    item: 'Beras SPHP',
    price: 10900,
    het: 10900,
    diff: 0,
    status: 'Compliant',
  },
  {
    id: 'PM-003',
    date: '19 Mei 2025',
    outlet: 'Sumber Rejeki',
    item: 'Beras SPHP',
    price: 10900,
    het: 10900,
    diff: 0,
    status: 'Compliant',
  },
  {
    id: 'PM-004',
    date: '19 Mei 2025',
    outlet: 'Toko Makmur',
    item: 'Beras SPHP',
    price: 11200,
    het: 10900,
    diff: 300,
    status: 'Violation',
  },
  {
    id: 'PM-005',
    date: '20 Mei 2025',
    outlet: 'Pasar Segar Sentosa',
    item: 'Gula Pasir',
    price: 14500,
    het: 14000,
    diff: 500,
    status: 'Violation',
  },
  {
    id: 'PM-006',
    date: '20 Mei 2025',
    outlet: 'Toko Berkah Jaya',
    item: 'Minyak Goreng',
    price: 15000,
    het: 14000,
    diff: 1000,
    status: 'Violation',
  },
]

export const procurementPlans = [
  {
    id: 'PROC-2025-001',
    title: 'Pengadaan DN Beras Masa Panen Raya',
    target: 500000,
    period: 'Mar - Mei 2025',
    status: 'Active',
    budget: 'Rp 7.5 T',
  },
  {
    id: 'PROC-2025-002',
    title: 'Import Beras G2G Vietnam',
    target: 200000,
    period: 'Apr 2025',
    status: 'Draft',
    budget: 'Rp 3.2 T',
  },
  {
    id: 'PROC-2025-003',
    title: 'Pengadaan Jagung Lokal',
    target: 150000,
    period: 'Jun - Jul 2025',
    status: 'Planning',
    budget: 'Rp 900 M',
  },
  {
    id: 'PROC-2025-004',
    title: 'Pengadaan Gula Pasir Lokal',
    target: 50000,
    period: 'Jun 2025',
    status: 'Planning',
    budget: 'Rp 600 M',
  },
  {
    id: 'PROC-2025-005',
    title: 'Pengadaan Minyak Goreng Curah',
    target: 80000,
    period: 'Jul 2025',
    status: 'Draft',
    budget: 'Rp 1.2 T',
  },
]

export const recipientBatches = [
  {
    id: 'BATCH-JKT-01',
    region: 'DKI Jakarta',
    count: 350000,
    source: 'P3KE Kemenko PMK',
    status: 'Verified',
    date: '2025-01-15',
  },
  {
    id: 'BATCH-JBR-01',
    region: 'Jawa Barat',
    count: 2100000,
    source: 'P3KE Kemenko PMK',
    status: 'Verified',
    date: '2025-01-20',
  },
  {
    id: 'BATCH-JTG-01',
    region: 'Jawa Tengah',
    count: 1800000,
    source: 'P3KE Kemenko PMK',
    status: 'In Review',
    date: '2025-02-01',
  },
  {
    id: 'BATCH-JTM-01',
    region: 'Jawa Timur',
    count: 1950000,
    source: 'P3KE Kemenko PMK',
    status: 'Verified',
    date: '2025-01-25',
  },
]

export const distributionOrders = [
  {
    id: 'DO-2025-001',
    date: '2025-05-20',
    dest: 'Pasar Induk Cipinang',
    program: 'SPHP Beras',
    qty: 10,
    status: 'In Transit',
    transporter: 'PT Pos Logistik',
    eta: '21 Mei 2025',
  },
  {
    id: 'DO-2025-002',
    date: '2025-05-20',
    dest: 'Kelurahan Kebon Jeruk',
    program: 'Bantuan Pangan',
    qty: 25,
    status: 'Delivered',
    transporter: 'DNR',
    eta: '20 Mei 2025',
  },
  {
    id: 'DO-2025-003',
    date: '2025-05-19',
    dest: 'RPK Sumber Rejeki',
    program: 'SPHP Beras',
    qty: 2,
    status: 'Planned',
    transporter: 'Swakelola',
    eta: '22 Mei 2025',
  },
  {
    id: 'DO-2025-004',
    date: '2025-05-18',
    dest: 'Pasar Tanah Abang',
    program: 'SPHP Beras',
    qty: 15,
    status: 'Loading',
    transporter: 'PT Pos Logistik',
    eta: '20 Mei 2025',
  },
  {
    id: 'DO-2025-005',
    date: '2025-05-20',
    dest: 'Pasar Segar Sentosa',
    program: 'SPHP Gula',
    qty: 5,
    status: 'In Transit',
    transporter: 'PT Pos Logistik',
    eta: '21 Mei 2025',
  },
  {
    id: 'DO-2025-006',
    date: '2025-05-19',
    dest: 'Toko Berkah Jaya',
    program: 'SPHP Minyak Goreng',
    qty: 3,
    status: 'Delivered',
    transporter: 'Swakelola',
    eta: '19 Mei 2025',
  },
]

export const auditLogs = [
  {
    time: '20 Mei 14:30',
    user: 'Admin Gudang JKT',
    action: 'Create GRN',
    module: 'Warehouse',
    detail: 'Created GRN #GRN-2025-089 untuk Beras Premium',
    ip: '192.168.1.45',
  },
  {
    time: '20 Mei 14:15',
    user: 'Admin Pusat',
    action: 'Approve Program',
    module: 'Program',
    detail: 'Approved SPHP Gula Pasir Q3 2025',
    ip: '10.0.5.12',
  },
  {
    time: '20 Mei 13:45',
    user: 'System',
    action: 'Auto-Allocation',
    module: 'Distribution',
    detail: 'Generated Allocation Plan #AL-99 untuk Minyak Goreng',
    ip: 'System',
  },
  {
    time: '20 Mei 13:30',
    user: 'Admin Program',
    action: 'Update Quota',
    module: 'Program',
    detail: 'Updated quota for PROG-001 (Beras SPHP)',
    ip: '10.0.5.15',
  },
  {
    time: '20 Mei 12:00',
    user: 'QC Officer',
    action: 'Block Lot',
    module: 'Warehouse',
    detail: 'Blocked LOT-MKS-005 (Beras Medium) due to quality issue',
    ip: '192.168.2.20',
  },
  {
    time: '20 Mei 11:30',
    user: 'Admin Gudang SBY',
    action: 'Create GRN',
    module: 'Warehouse',
    detail: 'Created GRN #GRN-2025-090 untuk Jagung Pakan',
    ip: '192.168.2.30',
  },
  {
    time: '20 Mei 10:45',
    user: 'QC Officer',
    action: 'Quality Check',
    module: 'Warehouse',
    detail: 'Quality check passed for LOT-JKT-005 (Daging Sapi Beku)',
    ip: '192.168.1.50',
  },
]
